import { Grid } from "@mui/material";
import { ReactNode } from "react";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Input from "../../../../../../../../components/Input";
import { PatientVital } from "../../../../../../../../services";
import {
  BLOOD_PRESSURE_ADULT_OPTS,
  BLOOD_PRESSURE_ARM_OPTS,
  BLOOD_PRESSURE_SITTING_OPTS,
  FLAG_OPTS,
  VitalFormik,
} from "../vital-constant";

type ResponsiveGrid = {
  children: ReactNode;
};

interface BloodPressureFieldsProps {
  formik: VitalFormik;
  ind: number;
}

const BloodPressureFields = ({ formik, ind }: BloodPressureFieldsProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  const selectHandleChange = (k: keyof PatientVital, v: string | null) => {
    formik.setFieldValue(getKey(k), v);
  };

  return (
    <Grid container gap={2}>
      <Grid xs={1.2}>
        <Input
          label="Systolic"
          required={isSelected}
          error={getError("systolic")}
          textFieldProps={{
            name: getKey("systolic"),
            value: activeVital?.systolic,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            placeholder: "e.g. 120 (mmHg)",
          }}
        />
      </Grid>
      <Grid xs={1.2}>
        <Input
          label="Diastolic"
          required={isSelected}
          error={getError("diastolic")}
          textFieldProps={{
            name: getKey("diastolic"),
            value: activeVital?.diastolic,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            placeholder: "e.g. 80 (mmHg)",
          }}
        />
      </Grid>
      <Grid xs={1.2}>
        <Input
          label="pulse"
          textFieldProps={{
            name: getKey("pulse"),
            value: activeVital?.pulse,
            onChange: formik.handleChange,
            placeholder: "e.g. 72 (BPM)",
          }}
        />
      </Grid>
      <ResponsiveGridItem>
        <CustomSelect
          name={getKey("value")}
          label="Sitting"
          placeholder="Sitting"
          required={isSelected}
          error={getError("value")}
          options={BLOOD_PRESSURE_SITTING_OPTS}
          value={activeVital?.value}
          onChange={(v) => selectHandleChange("value", v)}
          handleBlur={formik.handleBlur}
        />
      </ResponsiveGridItem>
      <ResponsiveGridItem>
        <CustomSelect
          name={getKey("method")}
          placeholder="Left Arm"
          options={BLOOD_PRESSURE_ARM_OPTS}
          value={activeVital?.method}
          onChange={(v) => selectHandleChange("method", v)}
        />
      </ResponsiveGridItem>
      <ResponsiveGridItem>
        <CustomSelect
          name={getKey("type")}
          placeholder="Adult"
          options={BLOOD_PRESSURE_ADULT_OPTS}
          value={activeVital?.type}
          onChange={(v) => selectHandleChange("type", v)}
        />
      </ResponsiveGridItem>

      <ResponsiveGridItem>
        <CustomSelect
          name={getKey("flag")}
          placeholder="Flag"
          options={FLAG_OPTS}
          value={activeVital?.flag}
          onChange={(v) => selectHandleChange("flag", v)}
        />
      </ResponsiveGridItem>
    </Grid>
  );
};

export default BloodPressureFields;

const ResponsiveGridItem = ({ children }: ResponsiveGrid) => (
  <Grid xs={1.7}>{children}</Grid>
);
